import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-783d9308"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "exchan" }
const _hoisted_3 = { class: "exchan-img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "exchan-title" }
const _hoisted_6 = { class: "exchan-jifen" }
const _hoisted_7 = { class: "exchan-jifen-left" }
const _hoisted_8 = { class: "exchan-jifen-right" }
const _hoisted_9 = { class: "exchan-button" }
const _hoisted_10 = { class: "exchan-tiler" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.t('me.integralExchange'),
      "left-arrow": "",
      fixed: "",
      "z-index": "99",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.back()))
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: $setup.ICON_EXAHNGE,
          alt: ""
        }, null, 8 /* PROPS */, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, _toDisplayString($setup.t('me.integralSuccess')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", null, _toDisplayString($setup.total_score ? $setup.total_score : 0), 1 /* TEXT */),
          _createElementVNode("p", null, _toDisplayString($setup.t('me.integralExchanged')), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", null, _toDisplayString($setup.score ? $setup.score : 0), 1 /* TEXT */),
          _createElementVNode("p", null, _toDisplayString($setup.t('me.integralNumber')), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.back()))
        }, _toDisplayString($setup.t('me.integralContinue')), 1 /* TEXT */),
        _createElementVNode("p", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.router.push('/integralMyStore')))
        }, _toDisplayString(_ctx.$t('me.ckwdhd')), 1 /* TEXT */)
      ]),
      _createElementVNode("p", _hoisted_10, _toDisplayString($setup.t('me.integralTips')), 1 /* TEXT */)
    ])
  ]))
}